import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "col col-12 col-md-8 offset-md-2 py-4" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "h2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "display-3 d-none d-md-block text-center" }, "Prescription Transfer", -1)),
      _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "display-4 d-block d-md-none text-center" }, "Prescription Transfer", -1)),
      _createElementVNode("form", {
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
        class: "mt-4"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("label", {
            class: "form-label",
            for: "pharmacyNameSearch"
          }, "Where do you want to pick up your prescription?", -1)),
          _createElementVNode("input", {
            type: "text",
            class: "form-control mb-2 me-sm-2",
            id: "pharmacyNameSearch",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pharmacyNameBeingSearched = $event.target.value)),
            placeholder: "🔎︎   Type pharmacy name here"
          }, null, 32)
        ])
      ], 32),
      (_ctx.prescriptionTransferResponse?.pharmacyName != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("h2", _hoisted_5, " How to Transfer to " + _toDisplayString(_ctx.prescriptionTransferResponse.pharmacyName), 1),
            _createElementVNode("p", null, [
              _createTextVNode("Transfers to " + _toDisplayString(_ctx.prescriptionTransferResponse.pharmacyName), 1),
              (_ctx.prescriptionTransferResponse.websiteDomain != null && _ctx.prescriptionTransferResponse.websiteDomain != '')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                    _cache[3] || (_cache[3] = _createTextVNode(" (", -1)),
                    _createElementVNode("u", null, _toDisplayString(_ctx.prescriptionTransferResponse.websiteDomain), 1),
                    _cache[4] || (_cache[4] = _createTextVNode(")", -1))
                  ]))
                : _createCommentVNode("", true),
              _cache[6] || (_cache[6] = _createTextVNode(" are handled by their staff. ", -1)),
              (_ctx.prescriptionTransferResponse.guestURL != null && _ctx.prescriptionTransferResponse.guestURL.length > 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Click the button below to go to the " + _toDisplayString(_ctx.prescriptionTransferResponse.pharmacyName) + " prescription transfer portal.", 1))
                : (_ctx.prescriptionTransferResponse.withAccountURL != null && _ctx.prescriptionTransferResponse.withAccountURL.length > 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Click the button below to go to the " + _toDisplayString(_ctx.prescriptionTransferResponse.pharmacyName) + " prescription transfer portal.", 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _cache[5] || (_cache[5] = _createTextVNode("Unfortunately, we are not aware of an online portal you can use to transfer your prescription so you need to call the pharmacy to initiate the transfer. We believe their phone number is: ", -1)),
                      _createElementVNode("a", {
                        href: 'tel:'+_ctx.prescriptionTransferResponse.phoneNumber
                      }, _toDisplayString(_ctx.prescriptionTransferResponse.phoneNumber), 9, _hoisted_10)
                    ]))
            ]),
            (_ctx.prescriptionTransferResponse.guestURL != null && _ctx.prescriptionTransferResponse.guestURL.length > 1)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "btn btn-lg btn-primary",
                  href: _ctx.prescriptionTransferResponse.guestURL
                }, "Go To Guest Transfer Portal", 8, _hoisted_11))
              : _createCommentVNode("", true),
            (_ctx.prescriptionTransferResponse.withAccountURL != null && _ctx.prescriptionTransferResponse.withAccountURL.length > 1)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "btn btn-lg btn-primary",
                  href: _ctx.prescriptionTransferResponse.withAccountURL
                }, "Go To Member Transfer Portal", 8, _hoisted_12))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}